import React, { Suspense, useCallback, useEffect, useState } from "react"
import styled from "styled-components"

import { INDEXES } from "../../constants/indexes"
import { ResultType } from "../../constants/resultType"
import { parseQueryStringFromURL } from "../../utils/parameters"
import { cleanupQuery } from "../../utils/transformer"
import DataTrackingProvider from "../DataTracking/DataTrackingProvider"
import ErrorBoundary from "../ErrorBoundary"
import { PostmateProvider } from "../PostmateProvider"
import SearchBar from "../SearchBar"
import Spinner from "../Spinner"
import StickyHeader from "../StickyHeader"
import AppStateContextProvider from "./AppStateContextProvider"
const NoResult = React.lazy(() => import("../NoResult"))
const NavList = React.lazy(() => import("./NavList"))
const SearchContent = React.lazy(() => import("./SearchContent"))

const Container = styled.div`
  width: 100%;
  max-width: 1232px;
  margin: auto;
`

const AppContent = () => {
  const appConfig = parseQueryStringFromURL(window.location.href)
  const [activeTab, setActiveTab] = useState<ResultType>(ResultType.ALL)
  const [query, setQuery] = useState(
    cleanupQuery(appConfig.searching.defaultQuery) || "",
  )
  const setQueryWithCleanUp = useCallback(
    (q) => {
      const queryAfterCleanup = cleanupQuery(q)
      queryAfterCleanup && setQuery(queryAfterCleanup)
    },
    [setQuery],
  )
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [query, activeTab])

  return (
    <Container>
      <AppStateContextProvider
        indexes={INDEXES}
        activeTab={activeTab}
        query={query}
      >
        <PostmateProvider setSearchQuery={setQueryWithCleanUp}>
          <DataTrackingProvider>
            <ErrorBoundary>
              <StickyHeader>
                <SearchBar
                  initialQuery={query}
                  onSubmit={setQueryWithCleanUp}
                />
                {query && (
                  <Suspense fallback={null}>
                    <NavList
                      indexes={INDEXES}
                      activeKey={activeTab}
                      onSelect={setActiveTab}
                    />
                  </Suspense>
                )}
              </StickyHeader>
              {!query && (
                <ErrorBoundary renderError={null}>
                  <Suspense fallback={<Spinner />}>
                    <NoResult>搜尋關鍵字</NoResult>
                  </Suspense>
                </ErrorBoundary>
              )}
              {query && (
                <ErrorBoundary>
                  <Suspense fallback={<Spinner />}>
                    <SearchContent
                      // hack for clear cache (including page number) when query is changed
                      // https://github.com/algolia/react-instantsearch/issues/2464#issuecomment-516752651
                      key={query}
                      activeKey={activeTab}
                      changeActiveTab={setActiveTab}
                      query={query}
                    />
                  </Suspense>
                </ErrorBoundary>
              )}
            </ErrorBoundary>
          </DataTrackingProvider>
        </PostmateProvider>
      </AppStateContextProvider>
    </Container>
  )
}

export default AppContent
